import { useContext, useEffect, useState } from "react";
import Offer from "../../components/offers/Offer";

import "./offers.css";

import Skeleton from "../../components/skeletons/Skeleton";
import { OffersContext } from '../../context/offers/OffersContext';
import { TenantContext } from "../../context/tenant/TenantContext";
import { LanguageContext } from "../../context/language/LanguageContext";
import { useRef } from "react";
import { ClientContext } from "../../context/client/ClientContext";
import { Link, useParams } from "react-router-dom";
import Banner from "../../components/Banner/Banner";
import { CategoriesContext } from "../../context/categories/CategoriesContext";
import FiveOfferThumb from "../../components/thumbnails/FiveOfferThumb";
import { CLOUDFRONT } from "../../utils/env";


export default function Offers() {
    const { client } = useContext(ClientContext)
    const { tenant } = useContext(TenantContext);
    const { offers } = useContext(OffersContext);
    const { categories } = useContext(CategoriesContext);

    const [offerslist, setOffersList] = useState([]);
    const [featuredOffersList, setFeaturedOffersList] = useState([]);

    const { language } = useContext(LanguageContext);
    const cboxFilter = useRef();

    const [loader, setLoader] = useState(false);
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [message, setMessage] = useState("");
    const [categoryList, setCategoryList] = useState([]);
    const params = useParams();
    
    // Carousel state and config
    const [currentIndex, setCurrentIndex] = useState(0);
    const [paused, setPaused] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const rotationInterval = 10000; // 10 seconds
    const shouldPauseOnHover = true; // Configure this as needed

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSlide = (direction) => {
        if (direction === 'next') {
            setCurrentIndex(current => {
                const maxIndex = isMobile ? 
                    featuredOffersList.length - 1 : 
                    featuredOffersList.length - 5;
                return current === maxIndex ? 0 : current + 1;
            });
        } else {
            setCurrentIndex(current => {
                const maxIndex = isMobile ? 
                    featuredOffersList.length - 1 : 
                    featuredOffersList.length - 5;
                return current === 0 ? maxIndex : current - 1;
            });
        }
    };

    // Auto-rotation effect
    useEffect(() => {
        if (!paused && featuredOffersList?.length > 5) {
            const interval = setInterval(() => {
                handleSlide('next');
            }, rotationInterval);

            return () => clearInterval(interval);
        }
    }, [paused, featuredOffersList]);

    const closeMessageModal = () => {
        setShowMessageModal(false);
    }

    const orderOffers = (off) => {

        let orderby = cboxFilter.current.value; //event.target.value;
        let filteredOffers = off && Array.isArray(off) ? [...off] : [...offerslist];
        if (orderby === "latest") {
            console.log("latest")

            filteredOffers.sort((a, b) => {
                const aPublished = new Date(a.published);
                const bPublished = new Date(b.published);

                return bPublished.getTime() - aPublished.getTime();
            });
        } else if (orderby === "endingsoon") {
            console.log("ending soon")
            filteredOffers.sort((a, b) => {
                console.log(a)
                console.log(b)
                const aValidTo = (a.validToUTC) ? new Date(a.validToUTC).getTime() : new Date().setDate(100000);
                const bValidTo = (b.validToUTC) ? new Date(b.validToUTC).getTime() : new Date().setDate(100000);
                console.log(aValidTo, " - ", bValidTo)
                return aValidTo - bValidTo;
            });
        } else if (orderby === "popularity") {
            console.log("popular")

            filteredOffers.sort((a, b) => {
                let aRedemptions = a.totalRedemptions || 0;
                let bRedemptions = b.totalRedemptions || 0;

                return bRedemptions - aRedemptions;
            });
        }

        // filteredOffers.map((ofr, index) => {
        //     if (index % 2 > 0)
        //         ofr.featuredOffer = true;
        // })

        let normal = filteredOffers.filter(ofr => ofr.featuredOffer === false);
        let featured = filteredOffers.filter(ofr => ofr.featuredOffer === true);




        setFeaturedOffersList(featured);
        setOffersList(normal);
    }

    const filterOffers = (event) => {
        let filterby = event.target.value;
        var filteredOffers = [];
        for (var i = 0, j = offers; i < j.length; i++) {

            if (j[i].title.toLowerCase().includes(filterby.toLowerCase()) ||
                j[i].merchant.image.toLowerCase().includes(filterby.toLowerCase())) {
                filteredOffers.push(j[i]);
            }
        }
        let normal = filteredOffers.filter(ofr => ofr.featuredOffer === false);
        let featured = filteredOffers.filter(ofr => ofr.featuredOffer === true);
        setFeaturedOffersList(featured);
        setOffersList(normal);
    }

    const setCategoriesList = (category) => {
        // console.log(category)
        let cats = [...categoryList];

        const boxes = document.querySelectorAll('.category');

        boxes.forEach(box => {
            box.classList.remove('catactive');


        });

        if (category === "all") {
            cats = [];
        } else {

            if (cats.indexOf(category) > -1) {

                cats.splice(cats.indexOf(category), 1);

            } else {

                cats.push(category)

            }
        }


        if (cats.length === 0) {
            const catItem = document.getElementById("catall")
            catItem.classList.add("catactive");
        } else {
            cats.map((thiscat, index) => {

                const catItem = document.getElementById(`cat${thiscat.split("/").join("").split(" ").join("")}`)
                catItem.classList.add("catactive");
            })
        }

        setCategoryList(cats);
        categoryFilter(cats)
    }

    const categoryFilter = (cats) => {


        //let filterby = event.target.value;
        var filteredOffers = [];

        let ordersOffers = [...offers];
        if (cats.length > 0) {


            for (var i = 0, j = ordersOffers; i < j.length; i++) {


                if (tenant?.tenantmasterconfig.api_version === "v1") {
                    if (cats.indexOf(j[i].merchant.category.name) > -1) {

                        filteredOffers.push(j[i]);
                    }
                } else {
                    for (var k = 0, l = cats; k < l.length; k++) {
                        if (l[k].category === j[i].targetMerchants[0].category.name) {
                            filteredOffers.push(j[i]);
                        }
                    }
                }





                // if (j[i].category.toLowerCase().includes(filterby.toLowerCase()) ||
                //     j[i].mName.toLowerCase().includes(filterby.toLowerCase())) {
                //     filteredOffers.push(j[i]);
                // }
            }
        } else {
            filteredOffers = [...ordersOffers];
        }

        let normal = filteredOffers.filter(ofr => ofr.featuredOffer === false);
        let featured = filteredOffers.filter(ofr => ofr.featuredOffer === true);
        setFeaturedOffersList(featured);
        setOffersList(normal);
        orderOffers(filteredOffers);
    }


    useEffect(() => {

        if (offers && offers.length > 0) {
            setCategoriesList("all");
            // setOffersList(offers);
            //  orderOffers();
        }
    }, [offers]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!params.searchtext) {
            document.getElementById("txtGlobalSearch").value = "";
        }
    }, [])





    return <div>
        <Banner />

        {
            (!tenant?.tenantmasterconfig.showfeaturedoffers && featuredOffersList?.length > 0) ?
                <section className="brand_area pt-4 pt-md-5 pb-50 wow fadeIn container" data-wow-duration="2s" data-wow-delay="0.5s">
                    <div className="section_title pb-4 pb-md-5">
                        <h4 className="sub_title">Featured offers</h4>
                    </div>
                    
                    <div id="divFeaturedContainer" className="featuredmaincontainer">
                        <button 
                            className="carousel-arrow prev" 
                            onClick={() => handleSlide('prev')}
                            aria-label="Previous slide"
                        >
                            <i className="bi bi-chevron-left"></i>
                        </button>
                        <div 
                            className="featuredContainer"
                            style={{ 
                                transform: isMobile 
                                    ? `translateX(calc(${-currentIndex * 75}vw - ${currentIndex * 20}px))` // Exactly one item (75vw) + gap (20px)
                                    : `translateX(${-currentIndex * 20}%)`,
                                width: 'auto'
                            }}
                            onMouseEnter={() => shouldPauseOnHover && setPaused(true)}
                            onMouseLeave={() => shouldPauseOnHover && setPaused(true)}
                        >
                            {featuredOffersList?.map((offer, index) => (
                                <div className="featured-item" key={index}>
                                    <FiveOfferThumb offer={offer} parenttype="page" />
                                </div>
                            ))}
                        </div>
                        <button 
                            className="carousel-arrow next" 
                            onClick={() => handleSlide('next')}
                            aria-label="Next slide"
                        >
                            <i className="bi bi-chevron-right"></i>
                        </button>
                    </div>
                </section>
                : ""
        }
        <section className="brand_area pt-4 pt-md-5 pb-50 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.5s">
            <div className="container">
                <div className="section_title pb-4 pb-md-5">
                    <h4 className="sub_title">Find more of what you love</h4>
                </div>

                <div className="catmaincontainer">
                    <div className="categoryContainer">
                        <div id="catall" className="d-inline-block category" onClick={() => { setCategoriesList("all") }}>
                            <div className="grid-icon mb-2"><img src={`${CLOUDFRONT}categories/${params.tenantpath}/All.svg`}
                                style={{ borderColor: tenant?.tenantmasterconfig.theme.primary_border_color }} /></div>
                            <div className="grid-label">All</div>
                        </div>
                        {
                            (categories) ?
                                categories?.filter(cat => !!cat).map((cat, index) => {
                                    return <div id={`cat${cat.split("/").join("").split(" ").join("")}`} className="d-inline-block category" key={index} onClick={() => { setCategoriesList(cat) }}>
                                        <div className="grid-icon mb-2"><img src={`${CLOUDFRONT}categories/${params.tenantpath}/${cat.split("/").join("")}.svg`}
                                            style={{ borderColor: tenant?.tenantmasterconfig.theme.primary_border_color }} /></div>
                                        <div className="grid-label">{cat}</div>
                                    </div>
                                })
                                :
                                <Skeleton type="category" count="7" />

                        }

                    </div>
                </div>
                <div className="mt-2">
                    {
                        categoryList?.map((catName, index) => {
                            return <span class="badge text-bg-secondary me-2 p-1" key={index}>
                                {catName}
                                <button type="button" class="btn-close ms-2 text-white" aria-label="Close"
                                    style={{ verticalAlign: "middle", fontSize: "10px" }} onClick={() => { setCategoriesList(catName) }}></button>
                            </span>
                        })

                    }
                </div>
            </div>
        </section>

        <section className="features_area">
            <div className="container">
                <div className="section_title pb-30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.5s">
                    <h4 className="sub_title d-inline-block">Offers</h4>
                    <div className=" d-inline-block" style={{ float: "right" }}>

                        <div className="selector">
                            <select ref={cboxFilter} className="form-select" aria-label="Default select example"
                                onChange={orderOffers} style={{ width: "125px" }}>
                                <option selected value="popularity">Popular</option>
                                <option value="latest">Latest</option>
                                <option value="endingsoon">Ending Soon</option>
                            </select>
                        </div>
                        <label style={{ float: "right", lineHeight: "28px", fontSize: "14px" }} className="d-none d-md-inline-block me-2">Offers sort by:</label>

                    </div>
                </div>

                <div className="row g-4" data-wow-duration="2s" data-wow-delay="0.5s">
                    {!offers ? (
                        <Skeleton type="offer" count="8" />
                    ) : offerslist.length > 0 ? (
                        offerslist?.map((offer) => {
                            return <Offer offer={offer} key={offer.id} />;
                        })
                    ) : (
                        <div className="text-center mt-4">
                            <h2>{language?.static_labels.nooffers}</h2>
                        </div>
                    )}
                </div>
            </div>
        </section>
    </div>
}
